import { render, staticRenderFns } from "./sourceNode.vue?vue&type=template&id=67f56821&scoped=true"
import script from "./sourceNode.vue?vue&type=script&lang=ts"
export * from "./sourceNode.vue?vue&type=script&lang=ts"
import style0 from "./sourceNode.vue?vue&type=style&index=0&id=67f56821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f56821",
  null
  
)

export default component.exports